import {
  MutationFunction,
  MutationKey,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  useMutation,
  useQuery
} from 'react-query';

export const buildMutation =
  <D, E, V>(mutationKey: MutationKey, mutationFn: MutationFunction<D, V>) =>
    (options?: Omit<UseMutationOptions<D, E, V>, 'mutationKey' | 'mutationFn'>): UseMutationResult<D, E, V> => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
      return useMutation<D, E, V>(mutationKey, mutationFn, options);
    };

export const buildQuery =
  <D, E>(queryKey: QueryKey, queryFn: QueryFunction<D>) =>
    (options?: Omit<UseQueryOptions<D, E>, 'queryKey' | 'queryFn'>): UseQueryResult<D, E> => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
      return useQuery(queryKey, queryFn, options);
    };
